import { MenuItem, MenuList, ListItemText } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import './AdminLeftMenu.scss';
import { AdminLeftMenuItem, adminLeftMenuSelector, setSelectedMenu } from './reducers/AdminLeftMenuReducer';

const AdminLeftMenu: React.FunctionComponent = () => {
    const adminLeftMenuData = useSelector(adminLeftMenuSelector);
    const dispatch = useDispatch();

    return (
        <>
            <MenuList>
                <MenuItem
                    onClick={() => {
                        dispatch(setSelectedMenu(AdminLeftMenuItem.UserManagement));
                    }}
                    selected={adminLeftMenuData.selectedMenu == AdminLeftMenuItem.UserManagement}
                >
                    <ListItemText>User Management</ListItemText>
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        dispatch(setSelectedMenu(AdminLeftMenuItem.Port));
                    }}
                    selected={adminLeftMenuData.selectedMenu == AdminLeftMenuItem.Port}
                >
                    <ListItemText>Port</ListItemText>
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        dispatch(setSelectedMenu(AdminLeftMenuItem.CargoType));
                    }}
                    selected={adminLeftMenuData.selectedMenu == AdminLeftMenuItem.CargoType}
                >
                    <ListItemText>Cargo Type</ListItemText>
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        dispatch(setSelectedMenu(AdminLeftMenuItem.DuplicateCheck));
                    }}
                    selected={adminLeftMenuData.selectedMenu == AdminLeftMenuItem.DuplicateCheck}
                >
                    <ListItemText>Duplicate Check</ListItemText>
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        dispatch(setSelectedMenu(AdminLeftMenuItem.DatabaseBackup));
                    }}
                    selected={adminLeftMenuData.selectedMenu == AdminLeftMenuItem.DatabaseBackup}
                >
                    <ListItemText>Database Backup</ListItemText>
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        dispatch(setSelectedMenu(AdminLeftMenuItem.MarketingMatchingConfig));
                    }}
                    selected={adminLeftMenuData.selectedMenu == AdminLeftMenuItem.MarketingMatchingConfig}
                >
                    <ListItemText>Matching Config</ListItemText>
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        dispatch(setSelectedMenu(AdminLeftMenuItem.InvalidCheck));
                    }}
                    selected={adminLeftMenuData.selectedMenu == AdminLeftMenuItem.InvalidCheck}
                >
                    <ListItemText>Invalid Check</ListItemText>
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        dispatch(setSelectedMenu(AdminLeftMenuItem.BulkImportTonnage));
                    }}
                    selected={adminLeftMenuData.selectedMenu == AdminLeftMenuItem.BulkImportTonnage}
                >
                    <ListItemText>Bulk Import Tonnage</ListItemText>
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        dispatch(setSelectedMenu(AdminLeftMenuItem.BulkImportMarketInfo));
                    }}
                    selected={adminLeftMenuData.selectedMenu == AdminLeftMenuItem.BulkImportMarketInfo}
                >
                    <ListItemText>Bulk Import Market Info</ListItemText>
                </MenuItem>
            </MenuList>
        </>
    )
};

export default AdminLeftMenu;